export const zoneData = [
  {
    country: '中国',
    timezone: '东八区',
    timezoneEn: 'EAST_8',
    capital: '北京',
    zoneOffset: 8,
  },
  {
    country: '阿富汗',
    timezone: '东四区',
    timezoneEn: 'EAST_4',
    capital: '喀布尔',
    zoneOffset: 4,
  },
  {
    country: '阿拉伯联合酋长国',
    timezone: '东四区',
    timezoneEn: 'EAST_4',
    capital: '阿布扎比',
    zoneOffset: 4,
  },
  {
    country: '阿曼',
    timezone: '东四区',
    timezoneEn: 'EAST_4',
    capital: '马斯喀特',
    zoneOffset: 4,
  },
  {
    country: '阿塞拜疆',
    timezone: '东四区',
    timezoneEn: 'EAST_4',
    capital: '巴库',
    zoneOffset: 4,
  },
  {
    country: '巴基斯坦',
    timezone: '东五区',
    timezoneEn: 'EAST_5',
    capital: '伊斯兰堡',
    zoneOffset: 5,
  },
  {
    country: '巴勒斯坦',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '耶路撒冷',
    zoneOffset: 2,
  },
  {
    country: '巴林',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '麦纳麦',
    zoneOffset: 3,
  },
  {
    country: '不丹',
    timezone: '东六区',
    timezoneEn: 'EAST_6',
    capital: '廷布',
    zoneOffset: 6,
  },
  {
    country: '朝鲜',
    timezone: '东九区',
    timezoneEn: 'EAST_9',
    capital: '平壤',
    zoneOffset: 9,
  },
  {
    country: '东帝汶',
    timezone: '东九区',
    timezoneEn: 'EAST_9',
    capital: '帝力',
    zoneOffset: 9,
  },
  {
    country: '菲律宾',
    timezone: '东八区',
    timezoneEn: 'EAST_8',
    capital: '马尼拉',
    zoneOffset: 8,
  },
  {
    country: '哈萨克斯坦',
    timezone: '东六区',
    timezoneEn: 'EAST_6',
    capital: '阿斯塔纳',
    zoneOffset: 6,
  },
  {
    country: '韩国',
    timezone: '东九区',
    timezoneEn: 'EAST_9',
    capital: '汉城',
    zoneOffset: 9,
  },
  {
    country: '吉尔吉斯斯坦',
    timezone: '东六区',
    timezoneEn: 'EAST_6',
    capital: '比什凯克',
    zoneOffset: 6,
  },
  {
    country: '柬埔寨',
    timezone: '东七区',
    timezoneEn: 'EAST_7',
    capital: '金边',
    zoneOffset: 7,
  },
  {
    country: '卡塔尔',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '多哈',
    zoneOffset: 3,
  },
  {
    country: '科威特',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '科威特城',
    zoneOffset: 3,
  },
  {
    country: '老挝',
    timezone: '东七区',
    timezoneEn: 'EAST_7',
    capital: '万象',
    zoneOffset: 7,
  },
  {
    country: '黎巴嫩',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '贝鲁特',
    zoneOffset: 2,
  },
  {
    country: '马尔代夫',
    timezone: '东五区',
    timezoneEn: 'EAST_5',
    capital: '马累',
    zoneOffset: 5,
  },
  {
    country: '马来西亚',
    timezone: '东八区',
    timezoneEn: 'EAST_8',
    capital: '吉隆坡',
    zoneOffset: 8,
  },
  {
    country: '蒙古',
    timezone: '东八区',
    timezoneEn: 'EAST_8',
    capital: '乌兰巴托',
    zoneOffset: 8,
  },
  {
    country: '孟加拉',
    timezone: '东六区',
    timezoneEn: 'EAST_6',
    capital: '达卡',
    zoneOffset: 6,
  },
  {
    country: '缅甸',
    timezone: '东六区',
    timezoneEn: 'EAST_6',
    capital: '仰光',
    zoneOffset: 6,
  },
  {
    country: '尼泊尔',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '加德满都',
    zoneOffset: 2,
  },
  {
    country: '日本',
    timezone: '东九区',
    timezoneEn: 'EAST_9',
    capital: '东京',
    zoneOffset: 9,
  },
  {
    country: '塞浦路斯',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '尼科西亚',
    zoneOffset: 2,
  },
  {
    country: '沙特阿拉伯',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '利雅得',
    zoneOffset: 3,
  },
  {
    country: '斯里兰卡',
    timezone: '东五区',
    timezoneEn: 'EAST_5',
    capital: '科伦坡',
    zoneOffset: 5,
  },
  {
    country: '塔吉克斯坦',
    timezone: '东五区',
    timezoneEn: 'EAST_5',
    capital: '杜尚别',
    zoneOffset: 5,
  },
  {
    country: '泰国',
    timezone: '东七区',
    timezoneEn: 'EAST_7',
    capital: '曼谷',
    zoneOffset: 7,
  },
  {
    country: '土耳其',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '安卡拉',
    zoneOffset: 2,
  },
  {
    country: '土库曼斯坦',
    timezone: '东五区',
    timezoneEn: 'EAST_5',
    capital: '阿什哈巴德',
    zoneOffset: 5,
  },
  {
    country: '文莱',
    timezone: '东八区',
    timezoneEn: 'EAST_8',
    capital: '斯里巴加湾市',
    zoneOffset: 8,
  },
  {
    country: '乌兹别克斯坦',
    timezone: '东五区',
    timezoneEn: 'EAST_5',
    capital: '塔什干',
    zoneOffset: 5,
  },
  {
    country: '新加坡',
    timezone: '东八区',
    timezoneEn: 'EAST_8',
    capital: '新加坡',
    zoneOffset: 8,
  },
  {
    country: '叙利亚',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '大马士革',
    zoneOffset: 2,
  },
  {
    country: '亚美尼亚',
    timezone: '东四区',
    timezoneEn: 'EAST_4',
    capital: '埃里温',
    zoneOffset: 4,
  },
  {
    country: '也门',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '亚丁',
    zoneOffset: 3,
  },
  {
    country: '伊拉克',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '巴格达',
    zoneOffset: 3,
  },
  {
    country: '伊朗',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '德黑兰',
    zoneOffset: 3,
  },
  {
    country: '以色列',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '特拉维夫',
    zoneOffset: 2,
  },
  {
    country: '印度',
    timezone: '东五区',
    timezoneEn: 'EAST_5',
    capital: '新德里',
    zoneOffset: 5,
  },
  {
    country: '印度尼西亚',
    timezone: '东七区',
    timezoneEn: 'EAST_7',
    capital: '雅加达',
    zoneOffset: 7,
  },
  {
    country: '约旦',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '安曼',
    zoneOffset: 2,
  },
  {
    country: '越南',
    timezone: '东七区',
    timezoneEn: 'EAST_7',
    capital: '河内',
    zoneOffset: 7,
  },
  {
    country: '格鲁吉亚',
    timezone: '东四区',
    timezoneEn: 'EAST_4',
    capital: '第比利斯',
    zoneOffset: 4,
  },
  {
    country: '阿尔巴尼亚',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '地拉那',
    zoneOffset: 1,
  },
  {
    country: '爱尔兰',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '都柏林',
    zoneOffset: 0,
  },
  {
    country: '爱沙尼亚',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '塔林',
    zoneOffset: 2,
  },
  {
    country: '安道尔',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '安道尔市',
    zoneOffset: 1,
  },
  {
    country: '奥地利',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '维也纳',
    zoneOffset: 1,
  },
  {
    country: '奥兰群岛',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    备注: '地区',
    zoneOffset: 2,
  },
  {
    country: '白俄罗斯',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '明斯克',
    zoneOffset: 2,
  },
  {
    country: '保加利亚',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '索非亚',
    zoneOffset: 2,
  },
  {
    country: '比利时',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '布鲁塞尔',
    zoneOffset: 1,
  },
  {
    country: '冰岛',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '雷克雅未克',
    zoneOffset: 0,
  },
  {
    country: '波兰',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '华沙',
    zoneOffset: 1,
  },
  {
    country: '波斯尼亚和黑塞哥维那',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '萨拉热窝',
    zoneOffset: 1,
  },
  {
    country: '布韦岛',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    备注: '地区',
    zoneOffset: 1,
  },
  {
    country: '丹麦',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '哥本哈根',
    zoneOffset: 1,
  },
  {
    country: '德国',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '柏林',
    zoneOffset: 1,
  },
  {
    country: '俄罗斯',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '莫斯科',
    zoneOffset: 3,
  },
  {
    country: '法国',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '巴黎',
    zoneOffset: 1,
  },
  {
    country: '法罗群岛',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '托尔斯港',
    zoneOffset: 0,
  },
  {
    country: '法属南部领地',
    timezone: '东五区',
    timezoneEn: 'EAST_5',
    capital: '马丁德维维埃',
    zoneOffset: 5,
  },
  {
    country: '梵蒂冈',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '梵蒂冈城',
    zoneOffset: 1,
  },
  {
    country: '芬兰',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '赫尔新基',
    zoneOffset: 2,
  },
  {
    country: '弗兰克群岛',
    timezone: '西三区',
    timezoneEn: 'WEST_3',
    capital: '斯坦利',
    zoneOffset: -3,
  },
  {
    country: '格恩西岛',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '圣彼得港',
    zoneOffset: 0,
  },
  {
    country: '荷兰',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '阿姆斯特丹',
    zoneOffset: 1,
  },
  {
    country: '捷克共和国',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '布拉格',
    zoneOffset: 1,
  },
  {
    country: '克罗地亚',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '萨格勒布',
    zoneOffset: 1,
  },
  {
    country: '拉脱维亚',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '里加',
    zoneOffset: 2,
  },
  {
    country: '立陶宛',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '维尔纽斯',
    zoneOffset: 2,
  },
  {
    country: '列支敦士登',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '瓦杜兹',
    zoneOffset: 1,
  },
  {
    country: '留尼旺岛',
    timezone: '东四区',
    timezoneEn: 'EAST_4',
    capital: '圣但尼',
    zoneOffset: 4,
  },
  {
    country: '卢森堡',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '卢森堡',
    zoneOffset: 1,
  },
  {
    country: '罗马尼亚',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '布加勒斯特',
    zoneOffset: 2,
  },
  {
    country: '马耳他',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '瓦莱塔',
    zoneOffset: 1,
  },
  {
    country: '马其顿',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '斯科普里',
    zoneOffset: 1,
  },
  {
    country: '曼岛',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '道格拉斯',
    zoneOffset: 0,
  },
  {
    country: '摩尔多瓦',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '基希讷乌',
    zoneOffset: 2,
  },
  {
    country: '摩纳哥',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '摩纳哥',
    zoneOffset: 1,
  },
  {
    country: '挪威',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '奥斯陆',
    zoneOffset: 1,
  },
  {
    country: '葡萄牙',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '里斯本',
    zoneOffset: 0,
  },
  {
    country: '瑞典',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '斯德哥尔摩',
    zoneOffset: 1,
  },
  {
    country: '瑞士',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '伯尔尼',
    zoneOffset: 1,
  },
  {
    country: '塞尔维亚',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '贝尔格莱德',
    zoneOffset: 1,
  },
  {
    country: '圣马力诺',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '圣马力诺',
    zoneOffset: 1,
  },
  {
    country: '斯洛伐克',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '布拉迪斯拉发',
    zoneOffset: 1,
  },
  {
    country: '斯洛文尼亚',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '卢布尔雅那',
    zoneOffset: 1,
  },
  {
    country: '斯瓦尔巴和扬马廷',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    备注: '地区',
    zoneOffset: 1,
  },
  {
    country: '乌克兰',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '基辅',
    zoneOffset: 2,
  },
  {
    country: '西班牙',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '马德里',
    zoneOffset: 1,
  },
  {
    country: '希腊',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '雅典',
    zoneOffset: 2,
  },
  {
    country: '匈牙利',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '布达佩斯',
    zoneOffset: 1,
  },
  {
    country: '意大利',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '罗马',
    zoneOffset: 1,
  },
  {
    country: '英国',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '伦敦',
    zoneOffset: 0,
  },
  {
    country: '泽西岛',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '圣赫利尔',
    zoneOffset: 0,
  },
  {
    country: '阿尔及利亚',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '阿尔及尔',
    zoneOffset: 1,
  },
  {
    country: '阿森松岛',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '乔治敦',
    zoneOffset: 0,
  },
  {
    country: '埃及',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '开罗',
    zoneOffset: 2,
  },
  {
    country: '埃塞俄比亚',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '亚的斯亚贝巴',
    zoneOffset: 3,
  },
  {
    country: '安哥拉',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '罗安达',
    zoneOffset: 1,
  },
  {
    country: '贝宁',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '波多诺伏',
    zoneOffset: 1,
  },
  {
    country: '博茨瓦纳',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '哈博罗内',
    zoneOffset: 2,
  },
  {
    country: '布基纳法索',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '瓦加杜古',
    zoneOffset: 0,
  },
  {
    country: '布隆迪',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '布琼布拉',
    zoneOffset: 2,
  },
  {
    country: '多哥',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '洛美',
    zoneOffset: 0,
  },
  {
    country: '厄立特里亚',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '阿斯马拉',
    zoneOffset: 3,
  },
  {
    country: '佛得角',
    timezone: '西一区',
    timezoneEn: 'WEST_1',
    capital: '普拉亚',
    zoneOffset: -1,
  },
  {
    country: '冈比亚',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '班珠尔',
    zoneOffset: 0,
  },
  {
    country: '刚果',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '布拉柴维尔',
    zoneOffset: 1,
  },
  {
    country: '刚果民主共和国',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '金沙萨',
    zoneOffset: 2,
  },
  {
    country: '吉布提',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '吉布提',
    zoneOffset: 3,
  },
  {
    country: '几内亚',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '科纳克里',
    zoneOffset: 0,
  },
  {
    country: '几内亚比绍',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '比绍',
    zoneOffset: 0,
  },
  {
    country: '加纳',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '阿克拉',
    zoneOffset: 0,
  },
  {
    country: '加蓬',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '利伯维尔',
    zoneOffset: 1,
  },
  {
    country: '津巴布韦',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '索尔兹伯里',
    zoneOffset: 2,
  },
  {
    country: '喀麦隆',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '雅温得',
    zoneOffset: 1,
  },
  {
    country: '科摩罗',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '莫罗尼',
    zoneOffset: 3,
  },
  {
    country: '科特迪瓦',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '亚穆苏克罗',
    zoneOffset: 0,
  },
  {
    country: '肯尼亚',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '内罗毕',
    zoneOffset: 3,
  },
  {
    country: '莱索托',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '马塞卢',
    zoneOffset: 2,
  },
  {
    country: '利比里亚',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '蒙罗维亚',
    zoneOffset: 0,
  },
  {
    country: '利比亚',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '的黎波里',
    zoneOffset: 2,
  },
  {
    country: '卢旺达',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '基加利',
    zoneOffset: 2,
  },
  {
    country: '马达加斯加',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '塔那那利佛',
    zoneOffset: 3,
  },
  {
    country: '马拉维',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '利隆圭',
    zoneOffset: 2,
  },
  {
    country: '马里',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '巴马科',
    zoneOffset: 0,
  },
  {
    country: '马约特岛',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '马穆楚',
    zoneOffset: 3,
  },
  {
    country: '毛里求斯',
    timezone: '东四区',
    timezoneEn: 'EAST_4',
    capital: '路易斯港',
    zoneOffset: 4,
  },
  {
    country: '毛里塔尼亚',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '努瓦克肖特',
    zoneOffset: 0,
  },
  {
    country: '摩洛哥',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '拉巴特',
    zoneOffset: 0,
  },
  {
    country: '莫桑比克',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '马普托',
    zoneOffset: 2,
  },
  {
    country: '纳米比亚',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '温得和克',
    zoneOffset: 2,
  },
  {
    country: '南非',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '比勒陀利亚',
    zoneOffset: 2,
  },
  {
    country: '尼日尔',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '尼亚美',
    zoneOffset: 1,
  },
  {
    country: '尼日利亚',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '拉各斯',
    zoneOffset: 1,
  },
  {
    country: '塞拉利昂',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '弗里敦',
    zoneOffset: 0,
  },
  {
    country: '塞内加尔',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '达喀尔',
    zoneOffset: 0,
  },
  {
    country: '塞舌尔',
    timezone: '东四区',
    timezoneEn: 'EAST_4',
    capital: '维多利亚',
    zoneOffset: 4,
  },
  {
    country: '圣多美和普林西比',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '圣多美',
    zoneOffset: 0,
  },
  {
    country: '圣赫勒拿',
    timezone: '零时区',
    timezoneEn: 'ZERO',
    capital: '詹姆士敦',
    zoneOffset: 0,
  },
  {
    country: '斯威士兰',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '姆巴巴纳',
    zoneOffset: 2,
  },
  {
    country: '苏丹',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '喀土穆',
    zoneOffset: 3,
  },
  {
    country: '索马里',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '摩加迪沙',
    zoneOffset: 3,
  },
  {
    country: '坦桑尼亚',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '达累斯萨拉姆',
    zoneOffset: 3,
  },
  {
    country: '突尼斯',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '突尼斯',
    zoneOffset: 1,
  },
  {
    country: '乌干达',
    timezone: '东三区',
    timezoneEn: 'EAST_3',
    capital: '坎帕拉',
    zoneOffset: 3,
  },
  {
    country: '英属印度洋领地',
    timezone: '东六区',
    timezoneEn: 'EAST_6',
    备注: '地区',
    zoneOffset: 6,
  },
  {
    country: '赞比亚',
    timezone: '东二区',
    timezoneEn: 'EAST_2',
    capital: '卢萨卡',
    zoneOffset: 2,
  },
  {
    country: '乍得',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '恩贾梅纳',
    zoneOffset: 1,
  },
  {
    country: '直布罗陀',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    备注: '地区',
    zoneOffset: 1,
  },
  {
    country: '中非共和国',
    timezone: '东一区',
    timezoneEn: 'EAST_1',
    capital: '班吉',
    zoneOffset: 1,
  },
  {
    country: '安提瓜岛和巴布达',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '圣约翰',
    zoneOffset: -4,
  },
  {
    country: '巴哈马',
    timezone: '西五区',
    timezoneEn: 'WEST_5',
    capital: '拿骚',
    zoneOffset: -5,
  },
  {
    country: '巴拿马',
    timezone: '西五区',
    timezoneEn: 'WEST_5',
    capital: '巴拿马城',
    zoneOffset: -5,
  },
  {
    country: '百慕大',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '哈密尔顿',
    zoneOffset: -4,
  },
  {
    country: '北马里亚纳群岛',
    timezone: '东十区',
    timezoneEn: 'EAST_10',
    capital: '塞班',
    zoneOffset: 10,
  },
  {
    country: '波多黎各',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '圣胡安',
    zoneOffset: -4,
  },
  {
    country: '伯利兹',
    timezone: '西六区',
    timezoneEn: 'WEST_6',
    capital: '贝尔莫潘',
    zoneOffset: -6,
  },
  {
    country: '多米尼加',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '圣地亚哥',
    zoneOffset: -4,
  },
  {
    country: '多米尼加共和国',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '圣多明各',
    zoneOffset: -4,
  },
  {
    country: '哥斯达黎加',
    timezone: '西六区',
    timezoneEn: 'WEST_6',
    capital: '圣何塞',
    zoneOffset: -6,
  },
  {
    country: '格林纳达',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '圣乔治',
    zoneOffset: -4,
  },
  {
    country: '格陵兰',
    timezone: '西三区',
    timezoneEn: 'WEST_3',
    capital: '努克',
    zoneOffset: -3,
  },
  {
    country: '古巴',
    timezone: '西五区',
    timezoneEn: 'WEST_5',
    capital: '哈瓦那',
    zoneOffset: -5,
  },
  {
    country: '瓜德罗普',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '巴斯特尔',
    zoneOffset: -4,
  },
  {
    country: '海地',
    timezone: '西五区',
    timezoneEn: 'WEST_5',
    capital: '太子港',
    zoneOffset: -5,
  },
  {
    country: '洪都拉斯',
    timezone: '西六区',
    timezoneEn: 'WEST_6',
    capital: '特古西虽尔巴',
    zoneOffset: -6,
  },
  {
    country: '加拿大',
    timezone: '西五区',
    timezoneEn: 'WEST_5',
    capital: '渥太华',
    zoneOffset: -5,
  },
  {
    country: '开曼群岛',
    timezone: '西五区',
    timezoneEn: 'WEST_5',
    capital: '乔治敦',
    zoneOffset: -5,
  },
  {
    country: '马提尼克',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    备注: '地区',
    zoneOffset: -4,
  },
  {
    country: '美国',
    timezone: '西五区',
    timezoneEn: 'WEST_5',
    capital: '华盛顿',
    zoneOffset: -5,
  },
  {
    country: '蒙特塞拉特',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '普利茅斯',
    zoneOffset: -4,
  },
  {
    country: '墨西哥',
    timezone: '西六区',
    timezoneEn: 'WEST_6',
    capital: '墨西哥城',
    zoneOffset: -6,
  },
  {
    country: '尼加拉瓜',
    timezone: '西六区',
    timezoneEn: 'WEST_6',
    capital: '马那瓜',
    zoneOffset: -6,
  },
  {
    country: '诺福克',
    timezone: '西五区',
    timezoneEn: 'WEST_5',
    capital: '金斯敦',
    zoneOffset: -5,
  },
  {
    country: '萨尔瓦多',
    timezone: '西六区',
    timezoneEn: 'WEST_6',
    capital: '圣萨尔瓦多',
    zoneOffset: -6,
  },
  {
    country: '圣基茨和尼维斯',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '巴斯特尔',
    zoneOffset: -4,
  },
  {
    country: '圣卢西亚',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '卡斯特里',
    zoneOffset: -4,
  },
  {
    country: '圣皮埃尔和米克隆群岛',
    timezone: '西三区',
    timezoneEn: 'WEST_3',
    capital: '圣皮埃尔市',
    zoneOffset: -3,
  },
  {
    country: '圣文森特和格林纳丁斯',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '金斯顿',
    zoneOffset: -4,
  },
  {
    country: '特克斯和凯克特斯群岛',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '科伯恩城',
    zoneOffset: -4,
  },
  {
    country: '特立尼达和多巴哥',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '西班牙港',
    zoneOffset: -4,
  },
  {
    country: '危地马拉',
    timezone: '西六区',
    timezoneEn: 'WEST_6',
    capital: '危地马拉城',
    zoneOffset: -6,
  },
  {
    country: '维尔京群岛，美属',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '夏洛特阿马利亚',
    zoneOffset: -4,
  },
  {
    country: '维尔京群岛，英属',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '罗德城',
    zoneOffset: -4,
  },
  {
    country: '牙买加',
    timezone: '西五区',
    timezoneEn: 'WEST_5',
    capital: '金斯敦',
    zoneOffset: -5,
  },
  {
    country: '阿根廷',
    timezone: '西二区',
    timezoneEn: 'WEST_2',
    capital: '布宜诺斯艾利斯',
    zoneOffset: -2,
  },
  {
    country: '阿鲁巴',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '奥莱涅斯塔德',
    zoneOffset: -4,
  },
  {
    country: '安圭拉',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '瓦利',
    zoneOffset: -4,
  },
  {
    country: '巴巴多斯岛',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '布里奇顿',
    zoneOffset: -4,
  },
  {
    country: '巴拉圭',
    timezone: '西三区',
    timezoneEn: 'WEST_3',
    capital: '亚松森',
    zoneOffset: -3,
  },
  {
    country: '巴西',
    timezone: '西三区',
    timezoneEn: 'WEST_3',
    capital: '巴西利亚',
    zoneOffset: -3,
  },
  {
    country: '玻利维亚',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '拉巴斯',
    zoneOffset: -4,
  },
  {
    country: '厄瓜多尔',
    timezone: '西五区',
    timezoneEn: 'WEST_5',
    capital: '基多',
    zoneOffset: -5,
  },
  {
    country: '法属圭亚那',
    timezone: '西三区',
    timezoneEn: 'WEST_3',
    capital: '卡宴',
    zoneOffset: -3,
  },
  {
    country: '哥伦比亚',
    timezone: '西五区',
    timezoneEn: 'WEST_5',
    capital: '波哥大',
    zoneOffset: -5,
  },
  {
    country: '圭亚那',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '乔治敦',
    zoneOffset: -4,
  },
  {
    country: '荷属安地列斯',
    timezone: '西四区',
    timezoneEn: 'WEST_4',
    capital: '威廉斯塔德',
    zoneOffset: -4,
  },
  {
    country: '秘鲁',
    timezone: '西五区',
    timezoneEn: 'WEST_5',
    capital: '利马',
    zoneOffset: -5,
  },
  {
    country: '苏里南',
    timezone: '西三区',
    timezoneEn: 'WEST_3',
    capital: '帕拉马里博',
    zoneOffset: -3,
  },
  {
    country: '委内瑞拉',
    timezone: '东四区',
    timezoneEn: 'EAST_4',
    capital: '加拉加斯',
    zoneOffset: 4,
  },
  {
    country: '乌拉圭',
    timezone: '西二区',
    timezoneEn: 'WEST_2',
    capital: '蒙得维的亚',
    zoneOffset: -2,
  },
  {
    country: '智利',
    timezone: '西三区',
    timezoneEn: 'WEST_3',
    capital: '圣地亚哥',
    zoneOffset: -3,
  },
  {
    country: '澳大利亚',
    timezone: '东十一区',
    timezoneEn: 'EAST_11',
    capital: '堪培拉',
    zoneOffset: 11,
  },
  {
    country: '巴布亚新几内亚',
    timezone: '东十区',
    timezoneEn: 'EAST_10',
    capital: '莫尔兹比港',
    zoneOffset: 10,
  },
  {
    country: '法属波利尼西亚',
    timezone: '西十区',
    timezoneEn: 'WEST_10',
    capital: '帕皮提',
    zoneOffset: -10,
  },
  {
    country: '斐济',
    timezone: '东十二区',
    timezoneEn: 'EAST_12',
    capital: '苏瓦',
    zoneOffset: 12,
  },
  {
    country: '关岛',
    timezone: '东十区',
    timezoneEn: 'EAST_10',
    capital: '阿加尼亚',
    zoneOffset: 10,
  },
  {
    country: '赫德和麦克唐纳群岛',
    timezone: '东五区',
    timezoneEn: 'EAST_5',
    备注: '地区',
    zoneOffset: 5,
  },
  {
    country: '基里巴斯',
    timezone: '东十二区',
    timezoneEn: 'EAST_12',
    capital: '拜里恩',
    zoneOffset: 12,
  },
  {
    country: '科科斯群岛',
    timezone: '东六区',
    timezoneEn: 'EAST_6',
    备注: '地区',
    zoneOffset: 6,
  },
  {
    country: '库克群岛',
    timezone: '西十区',
    timezoneEn: 'WEST_10',
    capital: '阿瓦鲁阿',
    zoneOffset: -10,
  },
  {
    country: '马绍尔群岛',
    timezone: '东十二区',
    timezoneEn: 'EAST_12',
    capital: '马朱罗',
    zoneOffset: 12,
  },
  {
    country: '美属萨摩亚',
    timezone: '西十一区',
    timezoneEn: 'WEST_11',
    capital: '帕果帕果',
    zoneOffset: -11,
  },
  {
    country: '密克罗尼西亚',
    timezone: '西六区',
    timezoneEn: 'WEST_6',
    capital: '帕利基尔',
    zoneOffset: -6,
  },
  {
    country: '瑙鲁',
    timezone: '东十二区',
    timezoneEn: 'EAST_12',
    capital: '瑙鲁',
    zoneOffset: 12,
  },
  {
    country: '纽埃',
    timezone: '西十一区',
    timezoneEn: 'WEST_11',
    capital: '阿洛菲',
    zoneOffset: -11,
  },
  {
    country: '帕劳群岛',
    timezone: '东九区',
    timezoneEn: 'EAST_9',
    capital: '科罗尔',
    zoneOffset: 9,
  },
  {
    country: '皮特凯恩',
    timezone: '西八区',
    timezoneEn: 'WEST_8',
    capital: '亚当斯敦',
    zoneOffset: -8,
  },
  {
    country: '萨摩亚',
    timezone: '西十一区',
    timezoneEn: 'WEST_11',
    capital: '阿皮亚',
    zoneOffset: -11,
  },
  {
    country: '圣诞岛',
    timezone: '东七区',
    timezoneEn: 'EAST_7',
    备注: '地区',
    zoneOffset: 7,
  },
  {
    country: '所罗门群岛',
    timezone: '东十一区',
    timezoneEn: 'EAST_11',
    capital: '霍尼亚拉',
    zoneOffset: 11,
  },
  {
    country: '汤加',
    timezone: '东十三区',
    capital: '努库阿洛法',
    zoneOffset: 13,
  },
  {
    country: '图瓦卢',
    timezone: '东十二区',
    timezoneEn: 'EAST_12',
    capital: '富纳富提',
    zoneOffset: 12,
  },
  {
    country: '托克劳',
    timezone: '东十三区',
    capital: '法考福',
    zoneOffset: 13,
  },
  {
    country: '瓦利斯和福图纳',
    timezone: '东十二区',
    timezoneEn: 'EAST_12',
    capital: '马塔乌图',
    zoneOffset: 12,
  },
  {
    country: '瓦努阿图',
    timezone: '东十一区',
    timezoneEn: 'EAST_11',
    capital: '维拉港',
    zoneOffset: 11,
  },
  {
    country: '新喀里多尼亚',
    timezone: '东十一区',
    timezoneEn: 'EAST_11',
    capital: '努美阿',
    zoneOffset: 11,
  },
  {
    country: '新西兰',
    timezone: '东十二区',
    capital: '惠灵顿',
    zoneOffset: 13,
  },
  {
    country: '南乔治亚和南桑德威奇群岛',
    timezone: '西二区',
    timezoneEn: 'WEST_2',
    capital: '',
    zoneOffset: -2,
  },
];

export const zoneVar = [
  { timezone: '零时区', timezoneEn: 'ZERO', value: 'ZERO', zoneOffset: 0 },
  { timezone: '东一区', timezoneEn: 'EAST_1', value: 'EAST_1', zoneOffset: 1 },
  { timezone: '东二区', timezoneEn: 'EAST_2', value: 'EAST_2', zoneOffset: 2 },
  { timezone: '东三区', timezoneEn: 'EAST_3', value: 'EAST_3', zoneOffset: 3 },
  { timezone: '东四区', timezoneEn: 'EAST_4', value: 'EAST_4', zoneOffset: 4 },
  { timezone: '东五区', timezoneEn: 'EAST_5', value: 'EAST_5', zoneOffset: 5 },
  { timezone: '东六区', timezoneEn: 'EAST_6', value: 'EAST_6', zoneOffset: 6 },
  { timezone: '东七区', timezoneEn: 'EAST_7', value: 'EAST_7', zoneOffset: 7 },
  { timezone: '东八区', timezoneEn: 'EAST_8', value: 'EAST_8', zoneOffset: 8 },
  { timezone: '东九区', timezoneEn: 'EAST_9', value: 'EAST_9', zoneOffset: 9 },
  { timezone: '东十区', timezoneEn: 'EAST_10', value: 'EAST_10', zoneOffset: 10 },
  { timezone: '东十一区', timezoneEn: 'EAST_11', value: 'EAST_11', zoneOffset: 11 },
  { timezone: '东十二区', timezoneEn: 'EAST_12', value: 'EAST_12', zoneOffset: 12 },
  { timezone: '东西十二区', timezoneEn: 'EAST_WEST_12', value: 'EAST_WEST_12', zoneOffset: 12 },
  { timezone: '西十二区', timezoneEn: 'WEST_12', value: 'WEST_12', zoneOffset: -12 },
  { timezone: '西十一区', timezoneEn: 'WEST_11', value: 'WEST_11', zoneOffset: -11 },
  { timezone: '西十区', timezoneEn: 'WEST_10', value: 'WEST_10', zoneOffset: -10 },
  { timezone: '西九区', timezoneEn: 'WEST_9', value: 'WEST_9', zoneOffset: -9 },
  { timezone: '西八区', timezoneEn: 'WEST_8', value: 'WEST_8', zoneOffset: -8 },
  { timezone: '西七区', timezoneEn: 'WEST_7', value: 'WEST_7', zoneOffset: -7 },
  { timezone: '西六区', timezoneEn: 'WEST_6', value: 'WEST_6', zoneOffset: -6 },
  { timezone: '西五区', timezoneEn: 'WEST_5', value: 'WEST_5', zoneOffset: -5 },
  { timezone: '西四区', timezoneEn: 'WEST_4', value: 'WEST_4', zoneOffset: -4 },
  { timezone: '西三区', timezoneEn: 'WEST_3', value: 'WEST_3', zoneOffset: -3 },
  { timezone: '西二区', timezoneEn: 'WEST_2', value: 'WEST_2', zoneOffset: -2 },
  { timezone: '西一区', timezoneEn: 'WEST_1', value: 'WEST_1', zoneOffset: -1 },
];
